import * as yup from 'yup';

/**
 * Yup schema for the AddressAutocomplete structural payload.
 *
 * Kept deliberately permissive: most fields are optional so manual entry and
 * partial suggestion fills both validate. Country is the only required field
 * because downstream consumers rely on it for country-specific rules layered
 * on top of this base schema via `.when('countryCode', ...)`.
 *
 * The concrete shape is inferred from the definition below rather than tied to
 * `TAddress`, because `TAddress` resolves to different types across apps
 * (fully-typed in the customer/admin portals, `any` in client-portal-integrations
 * which uses a pont stub). Inferring keeps the schema valid in every zone.
 */
export const addressAutocompleteSchema = yup
  .object({
    unitNumber: yup.string().optional(),
    streetNumber: yup.string().optional(),
    streetName: yup.string().optional(),
    streetType: yup.string().optional(),
    suburb: yup.string().optional(),
    city: yup.string().optional(),
    state: yup.string().optional(),
    postcode: yup.string().optional(),
    countryCode: yup.string().required('Country is required'),
  })
  .required();
